import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/vuex/store'
// create an axios instance
const service = axios.create({
  baseURL: '/',
  //withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent   
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
	  
	  if( store.getters.getToken )
	  {
		config.headers['token'] = store.getters.getToken
	  }      
    return config
  },
  error => {
    // do something with request error
    //console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.   
    if( res.code!=200 && res.code!=505)
	{
		 Message({
		  message: res.message,
		  type: 'error',
		  duration: 1 * 1000
		})
		return Promise.reject(res)
	}
	return res
  },
  error => {
    //console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 1 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js